/* @flow */
export default {
  black: {},
  danger: {
    backgroundColor_danger_active: '#fad4d4',
    backgroundColor_danger_focus: '#faf0f0',
    backgroundColor_danger_hover: '#faf0f0',
    backgroundColor_dangerPrimary: '#de1b1b',
    backgroundColor_dangerPrimary_active: '#b80d0d',
    backgroundColor_dangerPrimary_focus: '#de1b1b',
    backgroundColor_dangerPrimary_hover: '#f55353',
    borderColor_danger: '#de1b1b',
    borderColor_danger_active: '#b80d0d',
    borderColor_danger_focus: '#b80d0d',
    borderColor_danger_hover: '#f55353',
    color_danger: '#de1b1b',
    color_dangerPrimary: '#ffffff',
    color_danger_active: '#b80d0d',
    color_danger_focus: '#de1b1b',
    color_danger_hover: '#f55353',
    icon_color_danger: '#de1b1b',
    well_backgroundColor_danger: '#fad4d4',
    well_borderColor_danger: '#fa8e8e'
  },
  gray: {
    backgroundColor_active: '#ebeff5',
    backgroundColor_disabled: '#ebeff5',
    backgroundColor_hover: '#f5f7fa',
    borderColor: '#c8d1e0',
    color: '#333840',
    color_disabled: '#afbacc',
    color_mouse: '#58606e',
    color_readOnly: '#58606e',
    h1_color: '#333840',
    h2_color: '#58606e',
    h3_color: '#58606e',
    h4_color: '#58606e',
    h5_color: '#333840',
    h6_color: '#58606e',
    icon_color: '#58606e',
    input_backgroundColor_disabled: '#ebeff5',
    input_color_placeholder: '#8e99ab',
    panel_backgroundColor_inverted: '#434a54',
    panel_borderColor: '#ebeff5',
    panel_borderColor_inverted: '#434a54',
    well_backgroundColor: '#ebeff5'
  },
  success: {
    backgroundColor_success_active: '#abedc5',
    backgroundColor_success_focus: '#e1faeb',
    backgroundColor_success_hover: '#e1faeb',
    backgroundColor_successPrimary: '#2a854e',
    backgroundColor_successPrimary_active: '#20693d',
    backgroundColor_successPrimary_focus: '#2a854e',
    backgroundColor_successPrimary_hover: '#3ba164',
    borderColor_success: '#2a854e',
    borderColor_success_active: '#20693d',
    borderColor_success_focus: '#20693d',
    borderColor_success_hover: '#3ba164',
    color_success: '#2a854e',
    color_successPrimary: '#ffffff',
    color_success_active: '#20693d',
    color_success_focus: '#2a854e',
    color_success_hover: '#3ba164',
    icon_color_success: '#2a854e',
    well_backgroundColor_success: '#abedc5',
    well_borderColor_success: '#57c282'
  },
  theme: {
    backgroundColor_brand_selected: '#f0f5fc',
    backgroundColor_brand_selectedActive: '#accbfc',
    backgroundColor_brand_selectedHover: '#cfe0fc',
    backgroundColor_brandPrimary: '#3272d9',
    backgroundColor_brandPrimary_active: '#1d5bbf',
    backgroundColor_brandPrimary_focus: '#3272d9',
    backgroundColor_brandPrimary_hover: '#5691f0',
    borderColor_brand: '#3272d9',
    borderColor_brand_active: '#1d5bbf',
    borderColor_brand_focus: '#1d5bbf',
    borderColor_brand_hover: '#5691f0',
    color_brand: '#3272d9',
    color_brandPrimary: '#ffffff',
    color_brand_active: '#1d5bbf',
    color_brand_focus: '#3272d9',
    color_brand_hover: '#5691f0',
    icon_color_brand: '#3272d9'
  },
  warning: {
    backgroundColor_warning_active: '#fad8af',
    backgroundColor_warning_focus: '#fcf2e6',
    backgroundColor_warning_hover: '#fcf2e6',
    backgroundColor_warningPrimary: '#ad5f00',
    backgroundColor_warningPrimary_active: '#8a4d03',
    backgroundColor_warningPrimary_focus: '#ad5f00',
    backgroundColor_warningPrimary_hover: '#cf7911',
    borderColor_warning: '#ad5f00',
    borderColor_warning_active: '#8a4d03',
    borderColor_warning_focus: '#8a4d03',
    borderColor_warning_hover: '#cf7911',
    color_warning: '#ad5f00',
    color_warningPrimary: '#ffffff',
    color_warning_active: '#8a4d03',
    color_warning_focus: '#ad5f00',
    color_warning_hover: '#cf7911',
    icon_color_warning: '#ad5f00',
    well_backgroundColor_warning: '#fad8af',
    well_borderColor_warning: '#e89c3f'
  },
  white: {
    backgroundColor: '#ffffff',
    backgroundColor_focus: '#ffffff',
    color_inverted: '#ffffff',
    color_brandPrimary: '#ffffff',
    color_dangerPrimary: '#ffffff',
    color_successPrimary: '#ffffff',
    color_warningPrimary: '#ffffff',
    input_backgroundColor: '#ffffff',
    panel_backgroundColor: '#ffffff'
  }
};
